<valg-dk-page-layout
  [election]="election"
  [links]="links"
  [filterLinks]="filterLinks"
  [sideNavTitleType]="sideNavTitleType"
  [backLink]="breadcrumbs.previousBreadcrumb"
  [parentLinkType]="parentLinkType">
  <valg-dk-breadcrumbs #breadcrumbs></valg-dk-breadcrumbs>
  <div class="d-flex justify-content-between">
    <h1 class="h2 mt-0 mb-8 hyphenate">
      {{ 'page.details_page.title' | translate: {area: region} }}
    </h1>
    <button color="text-only" valgButton (click)="onDownloadReportClick()" class="hidden__sm">
      <mat-icon [svgIcon]="SvgIcon.Download"></mat-icon>
      {{ 'export_data.button_title' | translate }}
    </button>
  </div>
  <div class="row">
    <div class="col-12">      <valg-card [border]="true" [custom]="true">
        <valg-dk-count-status title="count_status.title" [resultType]="resultType" [candidateDataLoadState]="candidateDataLoadState" [updated]="countStatusUpdated" [data]="countStatus"></valg-dk-count-status>
      </valg-card>
    </div>
    <div class="col-12 col-lg-6">
      <valg-card [border]="true" [custom]="true" class="p-0" height="490px">
        <valg-dk-mandates-list [data]="mandatesList" [resultSummary]="resultSummary" [basedOnMissingResults]="mandateDistributionBasedOnMissingResults"></valg-dk-mandates-list>
      </valg-card>
    </div>
    <div class="col-12 col-lg-6">
      <valg-card [border]="true" [custom]="true" class="p-0" height="490px">
        <valg-dk-candidate-mandates [data]="candidateMandates" [resultSummary]="resultSummary" [basedOnMissingResults]="mandateDistributionBasedOnMissingResults"></valg-dk-candidate-mandates>
      </valg-card>
    </div>
    <div class="col-12">
      <ng-container *ngTemplateOutlet="valgDkElectionMapCard; context: { isDesktopView: false }"></ng-container>

      <valg-card [border]="true" [custom]="true" class="p-0">
        <valg-dk-expandable-party-list
          [data]="candidates"
          [isCandidateList]="true"
          [candidateDataLoadState]="candidateDataLoadState"
          title="parties_table.candidatelist_title"
          [isCandidateListTable]="true"
          [resultType]="resultType"
          [resultSummary]="resultSummary"
        ></valg-dk-expandable-party-list>
      </valg-card>
    </div>
    <div class="col-12 col-lg-6">

      <valg-card *ngIf="electoralCoalitions && electoralCoalitions.length > 0" [border]="true" [custom]="true" class="p-0">
        <valg-dk-electoral-coalition [data]="electoralCoalitions!"></valg-dk-electoral-coalition>
      </valg-card>

      <valg-card *ngIf="coalitionList && coalitionList.length > 0" [border]="true" [custom]="true" class="p-0">
        <valg-dk-coalition-list [data]="coalitionList!"></valg-dk-coalition-list>
      </valg-card>

      <valg-card [border]="true" [custom]="true" class="p-0">
        <valg-dk-top-candidates [resultSummary]="resultSummary" [resultType]="resultType" [data]="topCandidates"></valg-dk-top-candidates>
      </valg-card>
    </div>
    <div class="col-12 col-lg-6">
      <ng-container *ngTemplateOutlet="valgDkElectionMapCard; context: { isDesktopView: true }"></ng-container>

      <valg-card [border]="true" [custom]="true">
        <valg-dk-voting-details [data]="votingDetails" [resultSummary]="resultSummary" [list]="votingDetailsList" [resultType]="resultType" [candidateDataLoadState]="candidateDataLoadState"></valg-dk-voting-details>
      </valg-card>

    </div>
  </div>
</valg-dk-page-layout>

<ng-template #valgDkElectionMapCard let-isDesktopView="isDesktopView">
  <valg-card [ngClass]="isDesktopView ? 'd-none d-lg-block': 'd-lg-none'" [border]="true" [custom]="true" *ngIf="election && regionCode && election.isDisplayingMap">
    <h2 class="card-heading mb-0">{{ 'map.title.status_municipalities' | translate }}</h2>
    <valg-dk-election-map
      (areaClicked)="onAreaClick($event)"
      [electionYear]="election.electionYear"
      [electionType]="election.electionType"
      [regionCode]="regionCode"
      regionalLevel="municipalities"
      [mapAreasMapping]="mapAreasMapping">
    </valg-dk-election-map>
  </valg-card>
</ng-template>
